import React from 'react';
import withSessionCheck from '../../../withSessionCheck';

const CustomCalendar = ({ daysOfMonth }) => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Get the first day of the month (0: Sunday, 1: Monday, etc.)
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    // Get the total number of days in the month
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Create an array of the days of the week
    const daysOfWeek = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

    // Generate an array of all days in the month with availability data
    const calendarDays = [];
    for (let i = 0; i < firstDayOfMonth; i++) {
        calendarDays.push({ empty: true });
    }
    for (let i = 1; i <= daysInMonth; i++) {
        const dayData = daysOfMonth.find(d => new Date(d.Date).getDate() === i);
        const date = new Date(year, month, i);
        calendarDays.push({
            date: date,
            available: dayData ? dayData.IsAvailable : false,
            dayName: daysOfWeek[date.getDay()]
        });
    }

    // Ensure the calendar has a total of 42 cells (6 weeks)
    while (calendarDays.length < 31) {
        calendarDays.push({ empty: true });
    }

    return (
        <div style={styles.calendarContainer}>
            <h5 style={{ marginTop: '-10px' }}>{monthNames[month]} {year}</h5>
            <div style={styles.daysOfWeek}>
                {daysOfWeek.map((day, index) => (
                    <div key={index} style={styles.dayOfWeek}>
                        {day}
                    </div>
                ))}
            </div>
            <div style={styles.calendarGrid}>
                {calendarDays.map((day, index) => (
                    <div
                        key={index}
                        style={{
                            ...styles.calendarDay,
                            backgroundColor: day.empty ? 'transparent' : (day.available ? '#90ee90' : '#ffcccb'),
                            color: day.empty ? 'transparent' : '#000',
                            boxShadow: day.empty ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        {day.empty ? '' : (
                            <>
                                {/* <div>{day.dayName}</div> */}
                                <div>{day.date.getDate()}</div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

const styles = {
    calendarContainer: {
        textAlign: 'center',
        width: '500px',
        marginTop: '5px',
        padding: '20px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        height:'370px',
        
    },
    daysOfWeek: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px',
        marginTop: '-20px',
    },
    dayOfWeek: {
        width: '40px',
        fontWeight: 'bold',
        margin: '25px',
    },
    calendarGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)', // 7 days in a week
        justifyContent: 'center',
        marginTop: '-10px',
    },
    calendarDay: {
        // width: '60px',
        // height: '60px',
        // display: 'flex',
        // flexDirection: 'column',
        // justifyContent: 'center',
        // alignItems: 'center',
        // margin: '5px',
        // borderRadius: '5px',
        // border: '1px solid #e0e0e0',
        width: '40px',
        height: '40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '5px',
        borderRadius: '5px',
        border: '1px solid #e0e0e0',
    },
};

export default withSessionCheck(CustomCalendar);
